import Api from "../utils/axios";

export const InventoryApi = {
  createGRV: (payload) =>
    Api.post(`inventory/create-good-receipt-voucher`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  updateGRV: (id, payload) =>
    Api.put(`inventory/update-good-receipt-voucher/${id}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  getAllGRV: (payload, search = "") =>
    Api.post(
      `inventory/get-all-good-receipts-voucher?search=${search}`,
      payload
    ),
  createGIV: (payload) =>
    Api.post(`inventory/create-good-issued-voucher`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  updateGIV: (id, payload) =>
    Api.put(`inventory/update-good-issued-voucher/${id}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  getAllGIV: (payload, search = "") =>
    Api.post(`inventory/get-all-good-issued-voucher?search=${search}`, payload),

  getAllLedgerReport: (payload, search = "") =>
    Api.post(`inventory/get-all-stock-ledger-report?search=${search}`, payload),

  getAllOnHandReport: (payload, search = "") =>
    Api.post(
      `inventory/get-all-stock-on-hand-report?search=${search}`,
      payload
    ),
};
